var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg161Alarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.768,380.91c-2.034-10.857-12.484-18.009-23.342-15.974c-10.856,2.035-18.009,12.485-15.975,23.341 c1.51,8.055-2.031,13.795-4.275,16.5c-2.239,2.697-7.215,7.223-15.38,7.223H104.204c-8.165,0-13.141-4.525-15.38-7.223 c-2.244-2.705-5.785-8.445-4.275-16.5c5.673-30.272,17.056-50.183,28.064-69.439c13.369-23.384,27.193-47.565,27.193-84.839v-30 c0-63.067,51.263-115.072,114.302-115.987h3.781C320.715,88.925,371.807,140.93,371.807,204v30 c0,31.723,10.377,53.552,20.104,71.523c3.62,6.688,10.5,10.484,17.606,10.484c3.215,0,6.477-0.777,9.502-2.415 c9.715-5.257,13.327-17.395,8.069-27.108c-9.678-17.882-15.281-32.203-15.281-52.484v-30c0-41.161-15.943-80.037-44.894-109.466 c-24.81-25.221-56.667-40.96-91.106-45.304V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v29.289 c-76.458,9.92-136,75.892-136,154.711v30c0,26.647-9.673,43.566-21.919,64.986c-12.064,21.104-25.739,45.023-32.655,81.924 c-3.301,17.616,1.369,35.626,12.813,49.414C69.479,444.1,86.304,452,104.204,452h91.989c0,33.084,26.916,60,60,60s60-26.916,60-60 h91.603c17.9,0,34.725-7.9,46.158-21.676C465.398,416.537,470.068,398.526,466.768,380.91z M256.193,472c-11.028,0-20-8.972-20-20 h40C276.193,463.028,267.222,472,256.193,472z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg161Alarm);
export default __webpack_public_path__ + "static/media/161-alarm.efcdb9e1bc830d1c347cb9a4350e9327.svg";
export { ForwardRef as ReactComponent };